import { render, staticRenderFns } from "./toolbar.vue?vue&type=template&id=4532e118&scoped=true"
import script from "./toolbar.vue?vue&type=script&lang=js"
export * from "./toolbar.vue?vue&type=script&lang=js"
import style0 from "./toolbar.vue?vue&type=style&index=0&id=4532e118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4532e118",
  null
  
)

export default component.exports